import { compose } from 'redux';
import { connect } from 'react-redux';
import AvatarView from '../avatar/avatarView';
import withAvatar from '../avatar/withAvatar';
import InterstitialView from './InterstitialView';
import { completeAssessment } from '../start/startActions';
import selectors from '../../rootSelectors';

const mapStateToProps = state => ({
    recentlyCompletedMeasure: selectors.getRecentlyCompletedMeasure(state).name,
});

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.HIDDEN,
});

const mapDispatchToProps = dispatch => ({
    goToNextPage() {
        dispatch(completeAssessment());
    },
});

const InterstitialContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(InterstitialView);

export default InterstitialContainer;
